import { render, staticRenderFns } from "./truckVisit.vue?vue&type=template&id=a664af76&scoped=true"
import script from "./truckVisit.vue?vue&type=script&lang=js"
export * from "./truckVisit.vue?vue&type=script&lang=js"
import style0 from "./truckVisit.vue?vue&type=style&index=0&id=a664af76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a664af76",
  null
  
)

export default component.exports